import React, { useRef, useEffect, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import { t } from "i18next";
import { wglcsApiService } from "../../../services/WglcsApiService";
import InsightChatComponent from "./InsightsChatComponent";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { utils } from "../../../utils/index";

const RightsideBar = (props) => {
    const [visibleRight, setVisibleRight] = useState(false)
    const [dismisable, setDismisable] = useState(false)
    const [chatsidebar, setChatSidebar] = useState<boolean>(false)
    const [selectedchat, setSelectedChat] = useState<any>("")
    const [selectedchatid, setSelectedChatId] = useState<any>("")
    const [Chats, setChats] = useState<any>("")
    const [selectedquestion, setSelectedQuestion] = useState<any>("")
    // Create a ref for the sidebar
    const sidebarRef = useRef<any>(null);
    const [refreshState, setRefreshState] = useState<any>(new Date())

    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])

    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }

    useEffect(() => {
        if (props.visible) {
            setVisibleRight(true)
        }
    }, [props.visible])

    useEffect(() => {
        setChats(props?.getchats?.chats)
        setSelectedQuestion(props?.getchats?.data)
    }, [props?.getchats])

    useEffect(() => {
        // Add a click event listener to close the sidebar if clicked outside
        const handleClickOutside = (event) => {
            // Check if the click was outside the sidebar
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                if (event.target.nodeName === "DIV") {
                    // setVisibleRight(false);
                    // props.close();
                }
                else {
                    return ""
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);

        // Clean up the event listener
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCloseRightSideBar = () => {
        setVisibleRight(false)
        props.close()
    };

    const handleSelect = async (data) => {
        var chatdetail = await wglcsApiService.chatmessages_bychatid(data.chat_id)
        setSelectedChat(chatdetail?.data?.data)
        setSelectedChatId(data.chat_id)
        setChatSidebar(true)
    }
    const sidebarData = () => {
        return (
            <div className="insights-rightsidebar-container" style={{}}>
                {props?.getchats?.chats?.map((data, index) => (
                    <div style={{ backgroundColor: utils.isDarkMode() ? "#000000" : "white" }} className="insights-rightsidebar-item" key={index}>
                        <div className="insights-rightsidebar-details">
                            <span className="insights-rightsidebar-question">
                                {data.chatId}
                            </span>
                            <span className={data.billable === true ? "insights-rightsidebar-billed" : "insights-rightsidebar-notbilled"}>
                                {data.billable === true ? "Billed" : "Not Billed"}
                            </span>
                        </div>
                        <div onClick={() => handleSelect(data)} className="insights-rightsidebar-count">
                            <span>Read Conversation</span>
                            <i className="fa-solid fa-chevron-right"></i>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const hidesidebar = () => {
        setChatSidebar(false)
    }

    return (
        <>
            <div ref={sidebarRef}>
                <Sidebar
                    className="insights-rightsidebar"
                    dismissable={dismisable}
                    visible={visibleRight}
                    position="right"
                    onHide={() => handleCloseRightSideBar()}
                >
                    <div className="rightsidebar-header">
                        <label className="wgreport-label">{t("StaticReport-Text.All-Chats")}
                            <button className="rightsidebar-close-btn" onClick={handleCloseRightSideBar} aria-label="Close">
                                <i className="pi pi-times"></i>
                            </button>

                        </label>
                        <label className="insights-path">{props.path}</label>

                    </div>

                    {sidebarData()}
                    {chatsidebar &&
                        <InsightChatComponent
                            visible={chatsidebar}
                            hide={hidesidebar}
                            selectedchat={selectedchat}
                            selectedchatid={selectedchatid}
                            close={handleCloseRightSideBar}
                            selectedQuestion={selectedquestion}
                        />}
                </Sidebar>
            </div>  </>
    );
}

export default RightsideBar;
